import { useMemo } from "react";
/**
 * Hook to generate field grouping dynamically from section and sub_section in field schemas
 */
export var useFieldGrouping = function useFieldGrouping(fieldSchemas) {
  return useMemo(function () {
    var groupMap = new Map();

    // Build the structure: section -> sub_section -> fields
    fieldSchemas.forEach(function (field) {
      var section = field.section || "Other";
      var subSection = field.sub_section || "General";
      if (!groupMap.has(section)) {
        groupMap.set(section, new Map());
      }
      var sectionMap = groupMap.get(section);
      if (!sectionMap.has(subSection)) {
        sectionMap.set(subSection, new Set());
      }
      sectionMap.get(subSection).add(field.field_name);
    });

    // Convert to FieldGroup array format
    var groups = [];
    groupMap.forEach(function (subSections, sectionName) {
      var subSectionArray = [];
      subSections.forEach(function (fields, subSectionName) {
        subSectionArray.push({
          id: subSectionName.toLowerCase().replace(/\s+/g, "_"),
          label: subSectionName,
          fields: Array.from(fields)
        });
      });
      groups.push({
        id: sectionName.toLowerCase().replace(/\s+/g, "_"),
        heading: sectionName,
        sub_sections: subSectionArray
      });
    });
    return groups;
  }, [fieldSchemas]);
};